<template>
  <div>
    <label class="label">{{ label }}</label>
    <b-field>
      <b-autocomplete
        icon="search"
        class="control"
        :field="nameFormat ? 'formattedName' : 'name'"
        :data="filteredDataArray"
        :loading="$ajax.anyLoading"
        :placeholder="`${label}...`"
        :open-on-focus="true"
        :disabled="disabled"
        :clear-on-select="clearOnSelect"
        :expanded="nullable"
        v-model="name"
        v-on:typing="getAsyncData"
        v-on:select="(option) => emitSelected(option)"
      >
        <template slot="empty"
          >Nessun risultato, prova con un altro termine</template
        >
      </b-autocomplete>
      <div class="control" v-if="this.nullable && this.name">
        <b-tooltip label="Reset campo" position="is-left" animated>
          <a class="button is-outlined" v-on:click="handleReset">
            <b-icon
              pack="fas"
              icon="backspace"
              size="is-small"
              type="is-danger"
            ></b-icon>
          </a>
        </b-tooltip>
      </div>
    </b-field>
    <!--
    <pre class="has-text-left">{{searchOnFields}}</pre>
    <pre class="has-text-left">{{selected}}</pre>
    -->
  </div>
</template>


<script>
import debounce from "lodash/debounce";
import Vue from "vue";

export default {
  name: "search-product",
  props: {
    label: { type: String, required: true },
    apiaddress: { type: String, required: true },
    preload: { type: [String, Boolean], required: false },
    terms: { type: Object, required: false },
    disabled: { type: Boolean, required: false },
    clearOnSelect: { type: Boolean, required: false },
    nameFormat: { type: Function, required: false },
    searchOnFields: {
      type: [Array, String],
      required: false,
      default: "name",
      validator: function (value) {
        if (Array.isArray(value)) {
          if (value.length == 0) return false; // TODO: check if all elements is string
        } else if (typeof value === "string" || value instanceof String) {
          if (!value) return false;
        }
        return true;
      },
    },
    nullable: Boolean,
  },
  data() {
    return {
      selected: null,
      dataList: {},
      name,
    };
  },
  methods: {
    getAsyncData: debounce(function (input) {
      this.getData();
    }, 366),
    getData() {
      this.$ajax.request({
        address: this.apiaddress,
        silent: true,
        method: "POST",
        data: { term: this.name, limit: 10, ...this.terms },
        onSuccess: (response) => {
          response.data.forEach((item) => {
            let target = this.dataList;

            // do not override if exists
            if (!target[item.id]) {
              if (this.nameFormat) item.formattedName = this.nameFormat(item);
              Vue.set(target, item.id, item);
            }
          });
        },
      });
    },

    emitSelected: function (option) {
      if (!option && !this.nullable) return;
      this.selected = option;
      this.$emit("eventSelected", option);
    },

    searchOnFieldsFunc(element, propName, collection) {
      if (
        element[propName] &&
        element[propName]
          .toString()
          .toLowerCase()
          .indexOf(this.name.toLowerCase()) >= 0
      ) {
        var found = false;
        for (var i = 0; i < collection.length; i++) {
          if (collection[i].id === element.id) {
            found = true;
            break;
          }
        }

        if (!found) collection.push(element);
      }
    },

    handleReset() {
      this.name = "";
    },
  },
  computed: {
    filteredDataArray() {
      var collection = [];

      for (var index in this.dataList) {
        if (Array.isArray(this.searchOnFields)) {
          this.searchOnFields.forEach((e) =>
            this.searchOnFieldsFunc(this.dataList[index], e, collection)
          );
        } else {
          this.searchOnFieldsFunc(
            this.dataList[index],
            this.searchOnFields, // as string
            collection
          );
        }
      }

      return collection;
    },
  },
  mounted() {
    if (this.preload) {
      this.getData();
    }
  },
};
</script>
